import React from "react";
import { getRandomStaffData, getShandeAddressWithHref, getShandeContactWithHref1, getShandeEmailWithHref, getShandeFacebookWithHref, replaceStringWithShandeChildAmount } from "../helpers/dataHelper";
import { useTranslation } from "react-i18next";
import SEOComponent from "../components/SEOComponent";

function ContactUs() {
    const nameRef = React.useRef(null);
    const messageRef = React.useRef(null);
    const {t} = useTranslation();
    const contactCards = [
        {
            icon: "ion-ios-location",
            label: t("ourAddress"),
            value: getShandeAddressWithHref()
        },
        {
            icon: "ion-ios-telephone",
            label: "Office",
            value: getShandeContactWithHref1()
        },
        {
            icon: "ion-android-mail",
            label: "Email",
            value: getShandeEmailWithHref()
        },
        {
            icon: "ion-social-facebook",
            label: "Facebook",
            value: getShandeFacebookWithHref()
        }
    ];
    
    const redirectToWhatsApp = () => {
        let whatsappMessage = "";
        if(nameRef.current.value) {
            whatsappMessage += `${t("whatsappHi")} ${nameRef.current.value}. `
        }
        if(messageRef.current.value) {
            whatsappMessage += messageRef.current.value
        }
        const randomContact = getRandomStaffData("Contact", "Marketing");
        const whatsappURL = `https://api.whatsapp.com/send?phone=6${randomContact}&text=${whatsappMessage}`;
        window.open(whatsappURL, "_blank", "noopener,noreferrer");
    }
    
    const contactStructuredData = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact Shan De Children's Welfare Home",
        "description": "Get in touch with Shan De Children's Welfare Home in Johor Bahru. Contact us for donations, volunteering, or any inquiries about our charity work.",
        "url": "https://www.shandejohor.org.my/contactUs",
        "mainEntity": {
            "@type": "NGO",
            "name": "Pertubuhan Kebajikan Shan De",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Johor Bahru",
                "addressRegion": "Johor",
                "addressCountry": "MY"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+60-XX-XXXX-XXXX",
                "contactType": "customer service"
            }
        }
    };
    
    return (
        <>
        <SEOComponent 
            title="Contact Us"
            description="Get in touch with Shan De Children's Welfare Home in Johor Bahru. Contact us for donations, volunteering, sponsorship, or any inquiries about our charity work and children's welfare programs."
            keywords="contact us, phone number, address, email, WhatsApp, reach us, inquiries, volunteer contact"
            url="/contactUs"
            structuredData={contactStructuredData}
        />
        <section className="landing-page-hero">
            <div className="container">
                <div className="landing-page-hero-copy">
                    <div className="landing-page-kicker">{t("contactUs")}</div>
                    <h1 className="landing-page-title">{t("contactUs")}</h1>
                    <p className="landing-page-summary">{replaceStringWithShandeChildAmount(t("ctaDescription"))}</p>
                </div>
            </div>
        </section>

        <section className="landing-section landing-section-alt">
            <div className="container">
                <div className="landing-contact-grid">
                    <div className="landing-contact-card">
                        <div className="landing-eyebrow">{t("followUs")}</div>
                        <h2 className="landing-heading">{t("ourAddress")}</h2>
                        <p className="landing-section-desc">{t("needAnOfficialReceiptDescription")}</p>
                        <ul className="landing-contact-list">
                            {contactCards.map((item) => (
                                <li key={item.label}>
                                    <span className="landing-contact-icon"><i className={item.icon}></i></span>
                                    <div>
                                        <div className="landing-contact-label">{item.label}</div>
                                        <div className="landing-contact-value">{item.value}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="landing-contact-card">
                        <div className="landing-eyebrow">WhatsApp</div>
                        <h2 className="landing-heading">{t("contactViaWhatsapp")}</h2>
                        <p className="landing-section-desc">{t("makeDonationDescription")}</p>
                        <form className="landing-form">
                            <div>
                                <label className="landing-form-label" htmlFor="name">{t("yourName")}</label>
                                <input className="landing-form-input" type="text" id="name" ref={nameRef} />
                            </div>
                            <div>
                                <label className="landing-form-label" htmlFor="message">{t("message")}</label>
                                <textarea className="landing-form-textarea" id="message" ref={messageRef}></textarea>
                            </div>
                            <div>
                                <button className="landing-btn landing-btn-primary landing-form-submit" type="button" onClick={redirectToWhatsApp}>
                                    {t("contactViaWhatsapp")}
                                    <img src="assets/img/WhatsApp.svg.webp" alt="WhatsApp Icon" style={{ width: "30px", height: "30px" }} />
                                </button>
                            </div>
                        </form>
                        <p className="landing-form-note">{t("needAnOfficialReceipt")}</p>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}
export default ContactUs;